import * as yup from 'yup'

export const options = yup.object().shape({
  nombre: yup.string().required('El nombre es obligatorio'),
  aplicacionId: yup.string().required('El módulo es obligatorio'),
})
